// extracted by mini-css-extract-plugin
export default {"selectedUserContainer":"f724922b","resetIcon":"c5d4e536","textarea":"fb32ffb6"};